import { useState } from 'react'
import { animated, useSpring } from '@react-spring/web'
import { AppMarkdownViewer } from '../../atoms/AppMarkdownViewer/AppMarkdownViewer'
import { classNames } from 'primereact/utils'

interface FaqCategoryContentProps {
  title: string
  content: string
  images?: string[]
}
export const FaqCategoryContent = ({ title, content, images }: FaqCategoryContentProps) => {
  const [expanded, setExpanded] = useState(false)
  const buttonStyle = expanded ? 'text-white bg-orange' : 'text-orange bg-white'

  // Arrow animation
  const arrowAnimationStyle = useSpring({
    transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
  })
  const containerClasses = classNames({
    'p-12 rounded-2xl w-full max-w-[896px]': true,
    'shadow-[5px_5px_16px_0_rgba(255,106,19,0.15)] outline outline-2 outline-orange': expanded,
    'shadow-[0px_5px_16px_0_rgba(8,15,52,0.06)]': !expanded,
  })

  return (
    <div className={containerClasses}>
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          <h2 className="!m-0 text-3xl text-dark-blue whitespace-pre-line">
            <AppMarkdownViewer markdown={title} />
          </h2>
          <button className={`shadow-md p-8 rounded-full ${buttonStyle}`} onClick={() => setExpanded(!expanded)}>
            <animated.span style={arrowAnimationStyle} className={`pi pi-chevron-right font-bold`}></animated.span>
          </button>
        </div>
        <div
          className={`text-[1.6rem] font-medium break-word leading-10 whitespace-pre-wrap w-10/12 max-w-[720px] transition-all duration-300 ease-in-out ${
            expanded ? 'max-h-[3000px] opacity-100 mt-8 pb-12' : 'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          <div>
            <AppMarkdownViewer markdown={content} className="flex flex-col gap-4" />
            {images && images.map((image, i) => <img src={image} className="my-4 mb-8" alt="Faq example" key={i} />)}
          </div>
        </div>
      </div>
    </div>
  )
}
